import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/outline';

export function WarningBar({ 
  show = true, 
  message = "Purple highlighted sections are AI-generated. Please review carefully as AI can make mistakes. You are responsible for verifying all content.",
  icon = <ExclamationCircleIcon className="w-5 h-5 mr-1 text-violet-700" />,
  bgColor = "bg-violet-100",
  textColor = "text-slate-700",
  iconColor = "text-violet-700"
}) {
  return (
    <div className={`overflow-hidden transition-all duration-400 ease-in-out ${show ? 'max-h-24 opacity-100' : 'max-h-0 opacity-0'}`}>
      <div className={`${bgColor} mx-8 px-4 shadow-sm rounded-md mb-4 py-2`}>
        <div className="flex items-center max-w-screen-xl text-left">
          {icon}
          <p className={`text-xs ${textColor} font-semibold`}>
            {message}
          </p>
        </div>
      </div>
    </div>
  );
}

export default WarningBar;